
function initClickMarkers() {
	var markerClass = 'clickMarker';
	var marker = $('<span>', {
		"class" : markerClass
	});
	var markerSize = 10;

	// need this to be public
	window.addClickMarker = function(top, left, props) {
		var $newMarker = marker.clone().css({
			width: markerSize,
			height: markerSize,
			top: top - markerSize / 2,
			left: left  - markerSize / 2
		}).appendTo($('body'));

		if (props && props.className) {
			$newMarker.addClass(props.className);
		}
	}

	var clearMarkers = function() {
		console.log('clear markers');
		$('.' + markerClass).remove();
	}

	$(document).on(window.events.stimClick, function(e, originalEvent) {
		clearMarkers();//to be romoved when more clicks shall be implemented
		addClickMarker(originalEvent.clientY, originalEvent.clientX);
	});

	$(document).on(window.events.endTrial, function(e) {
		clearMarkers();
	});
}


function markClickedEntireStim(stim) {
	clearClickedStims();
	markStimClicked(stim);

	function markStimClicked(stim) {
		$(stim).addClass('clicked');
	}

	function clearClickedStims() {
		$('.clickableImage.clicked').removeClass('clicked');
	}
}
